// @flow

import { loginServiceActions } from './loginActionCreator';

const initialState = {
  submitClicked: null,
  isNewUserRegistration: false,
  error: null
};

const loginReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case loginServiceActions.GET_OTP: {
      return Object.assign({}, state, action.payload);
    }
    default: {
      return state;
    }
  }
};

export default loginReducer;
